// services/chassisApi.js
import { rootApi } from '../rootApi';

export const addPeriodApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getChassisList: builder.query({
            query: ({ searchText = '', pageSize = 50, pageNumber = 1 } = {}) => ({
                url: 'v1/addperiod/getchassisno',
                method: 'GET',
                params: {
                    SearchText: searchText || null,
                    PageSize: pageSize,
                    PageNumber: pageNumber
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data)) {
                    return response.data.map((item) => ({
                        id: item.id,
                        chassisNo: item.chassisNo
                    }));
                }
                return [];
            },
            providesTags: ['Chassis'],
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 getChassisList started');
                try {
                    const result = await queryFulfilled;
                    console.log('✅ Chassis list fetched:', result);
                } catch (error) {
                    console.error('❌ Error fetching chassis list:', error);
                }
            }
        })
    })
});

export const { useGetChassisListQuery } = addPeriodApi;
